import React, { useEffect, useState } from "react";
import { UserCircleIcon, UploadIcon } from "@heroicons/react/outline";
import axiosAPI from "../../utils/axios-api";

const API = process.env.REACT_APP_API;
function ChatBox(props) {
  const [komentar, setkomentar] = useState(null);
  const [list, setlist] = useState([]);
  const [userId, setuserId] = useState(0);

  useEffect(() => {
    let user = JSON.parse(localStorage.getItem("authenticatedUser"));
    setuserId(user.id);
    scrollDown();
    recieve();
  }, []);
  function scrollDown() {
    let scrollDiv = document.getElementById("moveToBottom");
    scrollDiv.scrollTop = scrollDiv.scrollHeight;
  }

  function send(params) {
    let body = {
      isi_komentar: komentar,
    };
    axiosAPI
      .post(API + "komentar/" + props.id + "/tambah", body)
      .then((res) => {
        console.log(res.data.data);
        recieve();
      });
  }

  function recieve(params) {
    axiosAPI.get(API + "komentar/" + props.id).then((res) => {
      setlist(res.data.data);
      setTimeout(() => {
        repeat();
      }, 1000);
    });
  }

  function repeat(params) {
    recieve();
  }

  function bubleLeft(params) {
    return (
      <div key={params.idx} className="flex justify-start my-2">
        <UserCircleIcon className="h-6 w-6 mr-2" />
        <div className="chat-bubble-left bg-blue-600 p-1 text-white rounded-b-xl rounded-r-xl">
          <div className="chat-bubble-content">
            <h1 className="text-left">{params.isi}</h1>
          </div>
          <div className="chat-bubble-content text-right mt-1">
            <h1 className="text-xs font-bold">15:12 PM</h1>
          </div>
        </div>
      </div>
    );
  }

  function bubleRight(params) {
    return (
      <div key={params.idx} className="flex justify-end my-2">
        <div className="chat-bubble-right bg-green-600 p-1 text-white rounded-t-xl rounded-l-xl">
          <div className="chat-bubble-content">
            <h1 className="text-left">{params.isi}</h1>
          </div>
          <div className="chat-bubble-content text-right mt-1">
            <h1 className="text-xs font-bold">15:12 PM</h1>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div
      className="block bg-white dark:bg-gray-800"
      style={{ minWidth: "300px", maxWidth: "100%", width: "100%" }}
    >
      <div className="flex flex-col">
        {/* Chat Content */}
        <div
          className="flex flex-col rounded-xl bg-gray-100 dark:bg-gray-900"
          style={{
            height: "calc(100% - 64px)",
            minHeight: "290px",
            position: "relative",
            flexGrow: 1,
          }}
        >
          <div className="flex overflow-hidden relative flex-grow">
            <div
              className="absolute left-0 right-0 overflow-y-auto px-4 h-full"
              id="moveToBottom"
            >
              <div className="relative flex flex-col min-h-full justify-end chat-content-container">
                <div>
                  {list.map((val, idx) => {
                    if (userId === val.user_id) {
                      return bubleRight({ isi: val.isi_komentar, key: idx });
                    } else {
                      return bubleLeft({ isi: val.isi_komentar, key: idx });
                    }
                  })}
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-row p-2">
            <div className="flex-1 rounded-xl mr-2">
              <input
                type="text"
                value={komentar}
                onChange={(e) => setkomentar(e.target.value)}
                className="w-full rounded-xl p-2 bg-gray-200 dark:bg-gray-800"
              />
            </div>
            <button
              onClick={() => {
                if (!!komentar) {
                  send();
                }
              }}
              className="p-2 rounded-lg bg-blue-400"
            >
              <UploadIcon className="h-6 w-6 text-white" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

ChatBox.propTypes = {};

export default ChatBox;
